import { EVENT_OPTIONS, DESCRIPTOR_TYPE_OPTIONS } from '@vlabs/api-bindings/src/constants';

import {
  allFacesColumns, defaultsFacesColumns, allEventsColumns, defaultsEventsColumns,
} from './constants';
import type { TFilters, TObjectType, TTaskFormValues } from './types';
import { columnsArrayToObject, columnsArrayToCheckboxTree, columnsArrayToKeyMap } from './utils';

const getDefaultValuesForFaces = (filters = {}) => ({
  content: {
    objects_type: EVENT_OPTIONS.faces,
    columns: columnsArrayToObject(defaultsFacesColumns),
    csv_delimiter: ',',
    save_images: 0,
    filters,
    descriptor: {
      type: DESCRIPTOR_TYPE_OPTIONS.face,
    },
  },
  columnsSettings: {
    all: allFacesColumns,
    defaults: defaultsFacesColumns,
    keyMap: columnsArrayToKeyMap(allFacesColumns, EVENT_OPTIONS.faces.value),
    tree: columnsArrayToCheckboxTree(allFacesColumns, EVENT_OPTIONS.faces.value),
  },
  notification_policy: {
    task_callbacks: [],
  },
});

const getDefaultValuesForEvents = (filters = {}) => ({
  content: {
    objects_type: EVENT_OPTIONS.events,
    columns: columnsArrayToObject(defaultsEventsColumns),
    csv_delimiter: ',',
    save_images: 0,
    filters,
    descriptor: {
      type: DESCRIPTOR_TYPE_OPTIONS.face,
    },
  },
  columnsSettings: {
    all: allEventsColumns,
    defaults: defaultsEventsColumns,
    keyMap: columnsArrayToKeyMap(allEventsColumns, EVENT_OPTIONS.events.value),
    tree: columnsArrayToCheckboxTree(allEventsColumns, EVENT_OPTIONS.events.value),
  },
  notification_policy: {
    task_callbacks: [],
  },
  meta: [],
});

export const getDefaultValuesByObjectType = (
  objectType: TObjectType,
  filters: TFilters,
): TTaskFormValues => {
  if (objectType === 'faces') return getDefaultValuesForFaces(filters);
  return getDefaultValuesForEvents(filters);
};
